import { render } from "./ScreenshotSlot.vue?vue&type=template&id=14f65a48&scoped=true"
import script from "./ScreenshotSlot.vue?vue&type=script&lang=js"
export * from "./ScreenshotSlot.vue?vue&type=script&lang=js"

import "./ScreenshotSlot.vue?vue&type=style&index=0&id=14f65a48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f65a48"]])

export default __exports__